module.exports = __webpack_public_path__ + "static/media/cubeLogo.6e293d80.png";